import { MouseEvent, useCallback } from "react";

import { useTheme } from "../../../context/theme";
import { DISABLED_OPACITY } from "../../../styles/colors/consts";
import { Box, Column, Columns } from "../../layout";
import styles from "./Checkbox.module.scss";

type Props = {
  name: string;
  checked?: boolean;
  partiallyChecked?: boolean;
  onChange: (e: React.SyntheticEvent<any>) => void;
  children?: React.ReactNode;
  disabled?: boolean;
};

export default function Checkbox({
  name,
  checked = false,
  partiallyChecked = false,
  onChange,
  children,
  disabled = false
}: Props) {
  const theme = useTheme();

  const stroke = checked
    ? theme["primary-high-content"]
    : theme["neutral-high-content"];

  const handleLabelClick = useCallback((event: MouseEvent) => {
    event.stopPropagation();
  }, []);

  return (
    <Box
      position="relative"
      component="label"
      htmlFor={name}
      display="flex"
      alignItems="center"
      onClick={handleLabelClick}
      opacity={disabled ? DISABLED_OPACITY : "1"}
      cursor={disabled ? "not-allowed" : "pointer"}
      className={styles.label}
    >
      <Columns space="large" alignY="center">
        <Column alignX="flex-start" width="content">
          <Box
            component="input"
            type="checkbox"
            onChange={onChange}
            disabled={disabled}
            checked={checked}
            name={name}
            id={name}
            position="absolute"
            left="-10000px"
            top="auto"
            width="1px"
            height="1px"
            opacity="0.0001"
            className={styles.input}
          />
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill={theme.foreground}
            aria-hidden="true"
            focusable="false"
            className={styles.svg}
          >
            <rect
              x="0.5"
              y="0.5"
              width="23"
              height="23"
              rx="1.5"
              stroke={stroke}
            />
            {checked && (
              <path
                d="M5 12.1852L9.30769 16.3333L19 7"
                stroke={stroke}
                strokeWidth="1.4"
              />
            )}
            {partiallyChecked && !checked && (
              <path d="M4 12.5H19" stroke={stroke} strokeWidth="1.4" />
            )}
          </svg>
        </Column>

        {children && <Column alignX="flex-start">{children}</Column>}
      </Columns>
    </Box>
  );
}
